import adapter from './adapter'
import { collectionGetters } from '@/store/collection'
import { RefundRescueCode } from './model'

const { getAll, getCollection, itemGetter, filteredGetter } = collectionGetters(adapter, {
  constructor: data => new RefundRescueCode(data)
})

export default {
  getAll,
  getCollection,
  getRefundRescueCode: itemGetter,
  getRefundRescueCodesByRefundId: (state, getters) => id => filteredGetter(state, getters)(rescueCode => rescueCode.refund_id === id),
}
